"use client";"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  default: () => src_default,
  isSameHost: () => isSameHost,
  isSamePageAnchor: () => isSamePageAnchor,
  toAbsoluteURL: () => toAbsoluteURL
});
module.exports = __toCommonJS(src_exports);
var React = __toESM(require("react"));

// src/HolyProgress.ts
var _HolyProgress = class _HolyProgress {
  /**
   * Create a HolyProgress instance.
   * @param {Partial<HolyProgressProps>} [customSettings] - Optional custom settings to override defaults.
   */
  constructor(customSettings) {
    /**
     * Sets the progress to a specific value.
     * @private
     * @param {number} n - The new progress value (0 to 1).
     * @returns {HolyProgress} The current instance for chaining methods.
     */
    this.setTo = /* @__PURE__ */ __name((n) => {
      const isStarted = typeof this.status === "number";
      n = this.clamp(n, this.settings.initialPosition, 1);
      this.status = n === 1 ? null : n;
      const progress = this.getOrCreateBar(!isStarted);
      if (progress === null) {
        return this;
      }
      const speed = this.settings.speed;
      this.repaint(progress);
      this.queue((next) => {
        const css = this.barPositionCSS(n);
        if (this.bar === null) {
          return;
        }
        Object.assign(this.bar.style, css, {
          transition: `all ${speed}ms ${this.settings.easing}`
        });
        if (n === 1) {
          progress.style.transition = "none";
          progress.style.opacity = "1";
          this.repaint(progress);
          setTimeout(() => {
            progress.style.transition = "all " + speed + "ms linear";
            progress.style.opacity = "0";
            setTimeout(() => {
              this.remove();
              next();
            }, speed);
          }, speed);
        } else {
          setTimeout(next, speed);
        }
      });
      return this;
    }, "setTo");
    /**
     * Clamps a number within the inclusive range specified by the given minimum and maximum.
     * @private
     * @param {number} n - The number to clamp.
     * @param {number} min - The lower boundary of the output range.
     * @param {number} max - The upper boundary of the output range.
     * @returns {number} The clamped value.
     */
    this.clamp = /* @__PURE__ */ __name((n, min, max) => {
      if (n < min)
        return min;
      if (n > max)
        return max;
      return n;
    }, "clamp");
    /**
     * Triggers a repaint on the specified HTML element.
     * This function is used to ensure that CSS transitions are properly triggered.
     * @private
     * @param {HTMLElement} obj - The HTML element to repaint.
     * @returns {HTMLElement} The same HTML element, for chaining.
     */
    this.repaint = /* @__PURE__ */ __name((obj) => {
      void obj.offsetWidth;
      return obj;
    }, "repaint");
    /**
     * Converts a progress value (0 to 1) into a percentage representation.
     * Used for calculating the visual width of the progress bar.
     * @private
     * @param {number} n - The progress value to convert.
     * @returns {number} The percentage representation of the progress value.
     */
    this.toBarPercentage = /* @__PURE__ */ __name((n) => {
      return (-1 + n) * 100;
    }, "toBarPercentage");
    /**
     * Initiates the progress bar's movement. If already started, it continues from the current position.
     * Automatically handles automatic incrementation ('trickle') if enabled.
     * @public
     * @returns {HolyProgress} The current instance for chaining methods.
     */
    this.start = /* @__PURE__ */ __name(() => {
      if (this.status === null) {
        this.setTo(0);
      }
      if (this.settings.trickle) {
        this.startTrickle();
      }
      return this;
    }, "start");
    /**
     * Performs automatic incrementation of the progress bar.
     * This function is recursive and continues to increment the progress at intervals defined by `trickleSpeed`.
     * @private
     */
    this.startTrickle = /* @__PURE__ */ __name(() => {
      const run = /* @__PURE__ */ __name(() => {
        if (this.status === null)
          return;
        this.increment();
        setTimeout(run, this.settings.trickleSpeed);
      }, "run");
      setTimeout(run, this.settings.trickleSpeed);
    }, "startTrickle");
    /**
     * Completes the progress, moving it to 100% and then hiding it.
     * Optionally, it can force completion even if the bar hasn't started.
     * @public
     * @param {boolean} [force] - Force completion even if the bar hasn't started.
     * @returns {HolyProgress} The current instance for chaining methods.
     */
    this.done = /* @__PURE__ */ __name((force) => {
      if (force === false && this.status === null)
        return this;
      return this.increment(0.3 + 0.5 * Math.random()).setTo(1);
    }, "done");
    /**
     * Calculates an increment value based on the current status of the progress.
     * This is used to determine the amount of progress to add during automatic incrementation.
     * @private
     * @param {number} status - The current progress status.
     * @returns {number} The calculated increment value.
     */
    this.calculateIncrement = /* @__PURE__ */ __name((status) => {
      if (status < 0.2)
        return 0.1;
      if (status < 0.5)
        return 0.04;
      if (status < 0.8)
        return 0.02;
      if (status < 0.99)
        return 5e-3;
      return 0;
    }, "calculateIncrement");
    /**
     * Increments the progress bar by a specified amount, or by an amount determined by `calculateIncrement` if not specified.
     * @private
     * @param {number} [amount] - The amount to increment the progress bar.
     * @returns {HolyProgress} The current instance for chaining methods.
     */
    this.increment = /* @__PURE__ */ __name((amount) => {
      if (this.status === null) {
        return this.start();
      }
      if (this.status > 1) {
        return this;
      }
      if (typeof amount !== "number") {
        amount = this.calculateIncrement(this.status);
      }
      this.status = this.clamp(this.status + amount, 0, 0.994);
      return this.setTo(this.status);
    }, "increment");
    /**
     * A function to manage the queue of operations to be performed on the progress bar.
     * It ensures that operations are executed in sequence.
     * @private
     * @returns {Function} A function that accepts a callback to be queued.
     */
    this.queue = /* @__PURE__ */ (() => {
      const pending = [];
      const next = /* @__PURE__ */ __name(() => {
        const fn = pending.shift();
        if (fn !== void 0) {
          fn(next);
        }
      }, "next");
      return (fn) => {
        pending.push(fn);
        if (pending.length === 1)
          next();
      };
    })();
    /**
     * Creates and initializes a new progress bar element in the DOM.
     * It sets up the necessary styles and appends the element to the document body.
     * @private
     * @param {boolean} fromStart - Indicates if the bar is created from the start position.
     * @returns {HTMLElement | null} The created progress bar element, or null if creation fails.
     */
    this.createBar = /* @__PURE__ */ __name((fromStart) => {
      var _a;
      const progress = document.createElement("div");
      progress.id = "holy-progress";
      progress.style.pointerEvents = "none";
      progress.innerHTML = '<div class="bar" role="bar"></div>';
      const bar = progress.querySelector('[role="bar"]');
      if (bar === null) {
        return null;
      }
      this.bar = bar;
      const percentage = fromStart ? "-100" : this.toBarPercentage((_a = this.status) != null ? _a : 0);
      this.bar.style.backgroundColor = this.settings.color;
      this.bar.style.height = this.settings.height + "px";
      this.bar.style.zIndex = this.settings.zIndex.toString();
      this.bar.style.position = "fixed";
      this.bar.style.width = "100%";
      this.bar.style.top = "0";
      this.bar.style.left = "0";
      this.bar.style.transition = "all 0 linear";
      this.bar.style.transform = "translate3d(" + percentage + "%,0,0)";
      document.body.appendChild(progress);
      return progress;
    }, "createBar");
    /**
     * Retrieves the existing progress bar element from the DOM, or creates a new one if not present.
     * @private
     * @param {boolean} fromStart - Indicates if the bar should be retrieved/created from the start position.
     * @returns {HTMLElement | null} The retrieved or newly created progress bar element.
     */
    this.getOrCreateBar = /* @__PURE__ */ __name((fromStart) => {
      const bar = document.getElementById("holy-progress");
      if (bar !== null) {
        return bar;
      }
      return this.createBar(fromStart);
    }, "getOrCreateBar");
    /**
     * Removes the progress bar element from the DOM.
     * This is typically called when the progress reaches 100% and is no longer needed.
     * @private
     */
    this.remove = /* @__PURE__ */ __name(() => {
      const progress = document.getElementById("holy-progress");
      progress !== null && progress.remove();
    }, "remove");
    /**
     * Determines the most suitable CSS positioning strategy based on browser capabilities.
     * Checks for transform properties with vendor prefixes and standard un-prefixed properties.
     * @private
     * @returns {TransformStrategy} - The optimal CSS positioning strategy ('translate3d', 'translate', or 'margin').
     */
    this.getTransformStrategy = /* @__PURE__ */ __name(() => {
      const style = document.body.style;
      const prefixes = ["Webkit", "Moz", "ms", "O", ""];
      let transformProp = "";
      for (let i = 0; i < prefixes.length; i++) {
        if (`${prefixes[i]}Transform` in style) {
          transformProp = prefixes[i];
          break;
        }
      }
      if (transformProp !== "" && `${transformProp}Perspective` in style) {
        return "translate3d";
      } else if (transformProp !== "") {
        return "translate";
      } else {
        return "margin";
      }
    }, "getTransformStrategy");
    /**
     * Generates the CSS for the progress bar position based on the detected positioning strategy.
     * Dynamically sets the transform or margin-left properties for the bar's position.
     * @private
     * @param {number} n - Position value of the bar, as a number between 0 and 1.
     * @returns {Object} - CSS styles for the progress bar.
     */
    this.barPositionCSS = /* @__PURE__ */ __name((n) => {
      const transformStrategy = this.getTransformStrategy();
      const barPosition = this.toBarPercentage(n) + "%";
      if (transformStrategy === "translate3d") {
        return { transform: `translate3d(${barPosition},0,0)` };
      }
      if (transformStrategy === "translate") {
        return { transform: `translate(${barPosition},0)` };
      }
      return { marginLeft: barPosition };
    }, "barPositionCSS");
    const defaultSettings = {
      initialPosition: 0.08,
      easing: "linear",
      speed: 200,
      trickle: true,
      trickleSpeed: 200,
      color: "#59a2ff",
      height: 4,
      zIndex: 2147483647
    };
    this.settings = __spreadValues(__spreadValues({}, defaultSettings), customSettings);
    this.status = null;
    this.bar = null;
  }
};
__name(_HolyProgress, "HolyProgress");
var HolyProgress = _HolyProgress;

// src/constants.ts
var DEFAULTS = {
  color: "#59a2ff",
  initialPosition: 0.08,
  trickleSpeed: 200,
  height: 4,
  trickle: true,
  easing: "ease",
  speed: 200,
  zIndex: 2147483647
};

// src/index.tsx
var toAbsoluteURL = /* @__PURE__ */ __name((url) => {
  return new URL(url, window.location.href).href;
}, "toAbsoluteURL");
var isSamePageAnchor = /* @__PURE__ */ __name((currentUrl, newUrl) => {
  const current = new URL(toAbsoluteURL(currentUrl));
  const next = new URL(toAbsoluteURL(newUrl));
  return current.href.split("#")[0] === next.href.split("#")[0];
}, "isSamePageAnchor");
var isSameHost = /* @__PURE__ */ __name((currentUrl, newUrl) => {
  const current = new URL(toAbsoluteURL(currentUrl));
  const next = new URL(toAbsoluteURL(newUrl));
  return current.hostname.replace(/^www\./, "") === next.hostname.replace(/^www\./, "");
}, "isSameHost");
var HolyLoader = /* @__PURE__ */ __name(({
  color = DEFAULTS.color,
  initialPosition = DEFAULTS.initialPosition,
  trickleSpeed = DEFAULTS.trickleSpeed,
  height = DEFAULTS.height,
  trickle = DEFAULTS.trickle,
  easing = DEFAULTS.easing,
  speed = DEFAULTS.speed,
  zIndex = DEFAULTS.zIndex
}) => {
  React.useEffect(() => {
    let holyProgress;
    const startProgress = /* @__PURE__ */ __name(() => {
      try {
        holyProgress.start();
      } catch (error) {
      }
    }, "startProgress");
    const stopProgress = /* @__PURE__ */ __name(() => {
      try {
        holyProgress.done();
      } catch (error) {
      }
    }, "stopProgress");
    const overridePushState = /* @__PURE__ */ __name(() => {
      const originalPushState = history.pushState.bind(history);
      history.pushState = (...args) => {
        stopProgress();
        originalPushState(...args);
      };
    }, "overridePushState");
    const handleClick = /* @__PURE__ */ __name((event) => {
      try {
        const target = event.target;
        const anchor = target.closest("a");
        if (anchor === null || anchor.target === "_blank" || event.ctrlKey || event.metaKey || // Skip if URL points to a different domain
        !isSameHost(window.location.href, anchor.href) || // Skip if URL is a same-page anchor (href="#", href="#top", etc.).
        isSamePageAnchor(window.location.href, anchor.href) || // Skip if URL uses a non-http/https protocol (mailto:, tel:, etc.).
        !toAbsoluteURL(anchor.href).startsWith("http")) {
          return;
        }
        startProgress();
        overridePushState();
      } catch (error) {
        stopProgress();
      }
    }, "handleClick");
    try {
      holyProgress = new HolyProgress({
        color,
        height,
        trickleSpeed,
        trickle,
        initialPosition,
        easing,
        speed,
        zIndex
      });
      document.addEventListener("click", handleClick);
    } catch (error) {
    }
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
}, "HolyLoader");
var src_default = HolyLoader;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isSameHost,
  isSamePageAnchor,
  toAbsoluteURL
});
//# sourceMappingURL=index.js.map